import React from "react";
import holidays from '../documents/Holiday List-Students-2024 (1).docx'
const HolidayList =()=>{
    const pdfFiles = [
        { name: ' HGS school Bhopal', url: '../newdocuments/Holiday list for students Bhopal.xlsx'},
        { name: ' HGS school Bhimtal', url: '../newdocuments/List of holiday Bhimtal.pdf'},
        { name: ' HGS school Anangpur', url: '../newdocuments/Holiday list anagpur.docx'},
        { name: ' HGS school Palla Nuh', url: '../newdocuments/Holiday List 2025-26.pdf' },
        { name: ' HGS school Varansi', url:'../newdocuments/HOLIDAY LIST 2025-26 varanasi.pdf' },
        { name: ' HGS school Jammu', url: '../newdocuments/Holidays list 2025-26 Jammu.docx'},
        { name: ' HGS school Faridabad', url:'../newdocuments/HGEI-Holiday List-2025.xlsx' },
    ]
    return (
        <div className="home_main">
          <div className="pdf-container">
          <table className="pdf-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>School Name</th>
                <th>Links</th>
              </tr>
            </thead>
            <tbody>
              {pdfFiles.map((file, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{file.name}</td>
                  <td>
                    <a href={file.url} target="_blank" rel="noopener noreferrer">
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    
        </div>
      );
}


export default  HolidayList;